import { render, staticRenderFns } from "./ContactFooter.vue?vue&type=template&id=dfcf7a9e&scoped=true&"
import script from "./ContactFooter.vue?vue&type=script&lang=js&"
export * from "./ContactFooter.vue?vue&type=script&lang=js&"
import style0 from "./ContactFooter.vue?vue&type=style&index=0&id=dfcf7a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcf7a9e",
  null
  
)

export default component.exports